import React, {Component} from 'react';
import '../css/Footer.css';

class Footer extends Component{
  constructor(props){
    super(props)
    this.state={
    }
  }
 
  render(){
    return(
      <div className='footer'>
        <div className='footLogo'>
            <img src='img/footLogo.png' alt='foot-logo'/>
        </div>
        <div className='copyright'>
            <div className='textBox01'>
                <div>Copyright ⓒ OceanlightAI Corp. All rights reserved.<span>(주)오션라이트에이아이</span></div>
                <div>대구광역시 동구 동대구로 465 대구스케일업허브 911호</div>
                <div>대표 : 박해광</div>
                <div>사업자번호 734-86-02013</div>
                <div className='newTab'>
                    <div><a href='#'>개인정보처리방침</a></div>
                    <div><a href='#'>이용약관</a></div>
                    <div><a href='#'>공지사항</a></div>
                </div>
            </div>
            <div className='textBox02'>
                <div>Oceanlightai@gmail.com</div>
            </div>
        </div>
      </div>
    )
  }
}

export default Footer;
